exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acd_popUpOuter2c-CR {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  top: 0;\n  left: 0; }\n  .acd_popUpOuter2c-CR .acd_maskpWGup {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.4);\n    left: 0;\n    top: 0; }\n", ""]);

// exports
exports.locals = {
	"popUpOuter": "acd_popUpOuter2c-CR",
	"mask": "acd_maskpWGup"
};